import { ApiService } from 'js/src/client/services.gen';

export const FALLBACK_CHART_CONFIG = {
    echarts: {
        backgroundColor: 'transparent',
        grid: { left: '3%', right: '3%', top: '3%', bottom: '3%', containLabel: true },
        xAxis: {
            type: 'category',
            data: ['A', 'B', 'C', 'D'],
            axisLabel: { fontSize: 56 },
        },
        yAxis: {
            type: 'value',
            axisLabel: { fontSize: 56 },
        },
        series: [
            {
                type: 'bar',
                barWidth: '60%',
                data: [
                    { value: 120, itemStyle: { color: 'themeRef_colors_0', borderRadius: 4 } },
                    { value: 200, itemStyle: { color: 'themeRef_colors_1', borderRadius: 4 } },
                    { value: 150, itemStyle: { color: 'themeRef_colors_2', borderRadius: 4 } },
                    { value: 80, itemStyle: { color: 'themeRef_colors_3', borderRadius: 4 } },
                ],
            },
        ],
    },
};

export type ChartGenerationOptions = {
    chartType?: string;
    data?: string;
    customPrompt?: string;
    /**
     * Currently-rendered ECharts config. When provided, the LLM is instructed to keep all
     * styling/animation/graphic structure from this config and only update data-bearing
     * fields (and the text strings inside title/graphic if the words become stale).
     */
    baseConfig?: unknown;
};

export type GeneratedChartConfig = { echarts?: unknown };

export async function generateChartConfig(
    sceneText: string,
    options?: ChartGenerationOptions,
): Promise<GeneratedChartConfig | undefined> {
    const { data: responseData } = await ApiService.generateChartConfigCreate({
        body: {
            scene_text: sceneText,
            chart_type: options?.chartType,
            chart_data: options?.data,
            custom_prompt: options?.customPrompt,
            base_config: options?.baseConfig,
        },
    });

    return responseData.config as GeneratedChartConfig | undefined;
}
